import { useState, useEffect } from "react";
import supabase from "../lib/supabase";
import { imgUrls } from "../lib/imageUrl";

export function useDailyDeals() {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let idleId = null;
    let timeoutId = null;

    async function fetch() {
      setLoading(true);
      const { data } = await supabase
        .from("daily_deal")
        .select(
          `
          *,
          bouquet:bouquet_id (
            id, bouquet_name, description, image_url, image_urls,
            flowers, size_prices,
            bouquet_occasion ( occasion:occasion_id ( name ) )
          )
        `,
        )
        .eq("is_active", true)
        .order("valid_till", { ascending: true });

      if (cancelled) return;

      const shaped = (data ?? []).map((d) => {
        const b = d.bouquet ?? {};
        const rawImgs = b.image_urls?.length ? b.image_urls : [b.image_url].filter(Boolean);
        const images      = imgUrls(rawImgs, { width: 600,  height: 750,  quality: 85, resize: "contain" });
        const images_full = rawImgs;
        const occasions = (b.bouquet_occasion ?? [])
          .map((bo) => bo.occasion?.name)
          .filter(Boolean);

        return {
          // deal-specific display fields
          id: d.id,
          bouquetId: d.bouquet_id,
          name: d.deal_name,
          desc: b.description ?? "",
          isDeal: d.is_deal === true,
          originalPrice: Number(d.price_before_deal),
          image: images[0] ?? null,
          validTill: d.valid_till,
          badge: "Today Only",

          // full product shape for ProductModal — deal price overrides bouquet price
          price: Number(d.deal_price),
          images,
          images_full,
          occasions,
          flowers: b.flowers ?? [],
          // deals are sold at one fixed price — no size picker
          size_prices: null,
          description: b.description ?? "",
          rating: null,
          ordered: 0,
          category: occasions[0]?.toLowerCase() ?? "other",
          is_featured: false,
          isDailyDeal: true,
        };
      });
      setDeals(shaped);
      setLoading(false);
    }

    // Daily deal section is below the fold — defer fetch until the main thread
    // is idle so it doesn't compete with hero render / LCP.
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      idleId = window.requestIdleCallback(fetch, { timeout: 1500 });
    } else {
      timeoutId = setTimeout(fetch, 800);
    }
    return () => {
      cancelled = true;
      if (idleId != null) window.cancelIdleCallback?.(idleId);
      if (timeoutId != null) clearTimeout(timeoutId);
    };
  }, []);

  return { deals, loading };
}
